import { Map } from 'immutable';

const emptyMap = Map();

/**
 * @param  {object} state - the redux store state
 * @param  {object} pandoraId - source pandoraId of curator (typically a station or playlist)
 * @returns {Map} - an immutable Map of the curator data
 */
export function getCuratorBySourcePandoraId(state: $TSFixMe, pandoraId: $TSFixMe): $TSFixMe {
  return state.entities.getIn(['curatorSources', pandoraId, 'curator'], emptyMap);
}

/**
 * @param  {object} state - the redux store state
 * @param  {object} pandoraId - source pandoraId of curator (typically a station or playlist)
 * @returns {object} - curator data ready for components to use
 */
export function mapCuratorProps(
  state: $TSFixMe,
  pandoraId: $TSFixMe,
): {
  curatorId: string | null;
  curatorName: string | null;
  curatorUrlPath: string | null;
} {
  const curator = getCuratorBySourcePandoraId(state, pandoraId);
  const curatorId = curator.get('pandoraId');

  if (!curatorId) {
    return {
      curatorId: null,
      curatorName: null,
      curatorUrlPath: null,
    };
  }

  return {
    curatorId,
    curatorName: curator.get('name'),
    curatorUrlPath:
      curator.getIn(['artist', 'shareableUrlPath'], null) || curator.get('shareableUrlPath'),
  };
}
